var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    width: 50,
    height: 50,
    rx: 12,
    fill: "#385CC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.143 13V37H25.5715V13H30.143Z",
    fill: "#385CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2856 13H32.9999C35.2091 13 36.9999 14.7909 36.9999 17V33C36.9999 35.2091 35.2091 37 32.9999 37H31.2856V13Z",
    fill: "#2E3E5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4286 13V37H19.8572V13H24.4286Z",
    fill: "#2E3E5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7143 13V37H17C14.7909 37 13 35.2091 13 33V17C13 14.7909 14.7909 13 17 13H18.7143Z",
    fill: "#385CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.716dcde32f54ff1f4826e735bcf4b277.svg";
export { ForwardRef as ReactComponent };